import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const AddClientSpecificContentWrapper = styled.div`
  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
  }
  .info-batch {
    ${responsive.MOBILE`
      margin-top: 16px;
    `}
  }

  .successMessage-text {
    color: ${COLORS.cirrus_black10};
    line-height: 22px;
    margin-bottom: 24px;
  }

  .MuiTableCell-root {
    border: none;
  }

  .MuiTableRow-root {
    background-color: ${COLORS.primary_light_blue1};
  }

  .group-name-container {
    padding: 24px 16px;

    ${responsive.MOBILE`
        padding: 0 16px 0 16px;
        width: 100%;
    `}
  }

  .note-info {
    min-width: 200px;
    background-color: ${COLORS.cirrus_orange_light};
    border: 1px solid ${COLORS.cirrus_orange_dark};
    border-radius: 8px;
    margin: 16px;
    padding: 16px;
    color: ${COLORS.cirrus_black};
  }

  .add-resource-button-container {
    display: flex;
    justify-content: flex-end;
    padding: 32px 32px;
    background-color: ${COLORS.cirrus_white};
    border-top: 1px dashed ${COLORS.primary_light_blue};

    ${responsive.MOBILE`
        padding: 16px 16px;
     `}
    .btn-tertiary {
      height: auto;
    }

    .add-resource-button,
    .add-template-button {
      background-color: ${COLORS.cirrus_white};
    }
  }

  .accordion-resource-header {
    margin-bottom: 24px !important;

    ${responsive.MOBILE`
        padding: 16px 8px;
        margin-bottom: 0 !important;
     `}
  }

  .resource-header-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .template-header-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .content-header {
    padding: 0px 16px;
    ${responsive.MOBILE`
       padding: 0px 8px;
       display: flex;
       align-items: center;
       justify-content: space-between;
    `}
  }

  .content-header-right {
    align-items: center;
    display: flex;
    justify-content: flex-end;

    .MuiButton-root {
      height: auto;
      padding-left: 4px;

      ${responsive.MOBILE`
         bottom: 8px;
    `}

      svg {
        margin-right: 10px;
      }
    }
  }

  .content-header-left {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }

  .add-icon {
    margin-right: 6px;
  }

  .MuiGrid2-root {
    margin-top: 40px;

    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}
    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
        }
    `}
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    padding: 24px 16px 0px;

    ${responsive.MOBILE`
     padding: 16px 8px 0 8px;
     `}
  }

  .semi-header {
    justify-items: right;
    padding: 8px 16px 8px 0px;
  }
`;
